module.exports = __webpack_public_path__ + "img/spitter-attack-mask-1.4869d4c3.png";